import axios from "axios";

export default function duplicateCompanyGroup({ name, uuid }) {
  return new Promise((resolve, reject) => axios
    .post(`/account/system-admin/api/v1/company-group/${uuid}`, {
      name,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
